module.exports = __webpack_public_path__ + "img/card-aamar-akbar.f57fc47.jpg";